import type { PurchaseHistory } from '../modules/DataTransformSchema';

type EscapeCSVValue = (value?: string | number | Date) => string;

const escapeCSVValue: EscapeCSVValue = (value) => {
  if (value == null) return '';

  const str =
    value instanceof Date ? value.toISOString().split('T')[0] : String(value);

  // If value contains comma, newline, or double quote, wrap in quotes and escape quotes
  if (str.includes(',') || str.includes('\n') || str.includes('"')) {
    return `"${str.replace(/"/g, '""')}"`;
  }

  return str;
};

type CSVHeaderConfig = Record<keyof PurchaseHistory, string>;

const CSV_HEADERS_CONFIG: CSVHeaderConfig = {
  order_date: 'Order Date',
  product_name: 'Product Name',
  product_price: 'Product Price',
  quantity: 'Quantity',
  quantity_unit: 'Quantity Unit',
  product_image: 'Product Image',
  product_url: 'Product URL',
  order_total: 'Order Total',
  order_id: 'Order ID',
  shipment_status: 'Shipment Status',
};

const CSV_FIELD_KEYS = Object.keys(CSV_HEADERS_CONFIG) as Array<
  keyof PurchaseHistory
>;

export function convertToCSV(orders: PurchaseHistory[]): string {
  const headers = CSV_FIELD_KEYS.map((key) => CSV_HEADERS_CONFIG[key]).join(
    ','
  );

  const rows = orders.map((order) =>
    CSV_FIELD_KEYS.map((key) => escapeCSVValue(order[key])).join(',')
  );

  return [headers, ...rows].join('\n');
}
